export default "assets/images/icons/arrow-slider-ced73b91.svg";